import { render, staticRenderFns } from "./PDFSubmission.vue?vue&type=template&id=6db376ec&scoped=true&"
import script from "./PDFSubmission.vue?vue&type=script&lang=js&"
export * from "./PDFSubmission.vue?vue&type=script&lang=js&"
import style0 from "./PDFSubmission.vue?vue&type=style&index=0&id=6db376ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db376ec",
  null
  
)

export default component.exports